import { render, staticRenderFns } from "./column-item.vue?vue&type=template&id=727e4d44&"
import script from "./column-item.vue?vue&type=script&lang=ts&"
export * from "./column-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports